import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderByButtonComponent } from './order-by-button.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [OrderByButtonComponent],
  imports: [CommonModule, ButtonModule],
  exports: [OrderByButtonComponent],
})
export class OrderByButtonModule {}
